import React from 'react';
import { Checkbox, CheckboxProps } from '@blueprintjs/core';

/**
 * Wraps the Blueprint Checkbox, which is different from the default
 * component, which wraps the blueprint-form checkbox and is meant to be
 * used in forms. This checkbox is for other use cases.
 */
const BPCheckbox: React.FC<CheckboxProps> = (props) => {
  return <Checkbox {...props} />;
};

export default BPCheckbox;
